import http from "../../http-common";

const getAll = async (query) => {
  return await http
    .get("/admin/companies", { params: query })
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

export default {
  getAll,
};
